export const formatDateTime = (value) => {
  if (!value) return 'Never';
  try {
    return new Intl.DateTimeFormat('en', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(value));
  } catch {
    return 'Never';
  }
};

export const getReadableGiftSetError = (error) => {
  const message = error.message || 'Something went wrong.';
  if (error.code === 'functions/already-exists') {
    return 'That Gift Set name is already used. Please choose another name.';
  }
  if (error.code === 'functions/failed-precondition') {
    return message;
  }
  if (error.code === 'functions/permission-denied') {
    return 'Your admin session expired. Please unlock editing again.';
  }
  return message;
};
